<template>
  <svg
    width="36"
    height="24"
    viewBox="0 0 36 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_20043_1779385)">
      <rect x="0.5" y="0.5" width="35" height="23" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="35" height="23" rx="3.5" stroke="#CCCFD7" />
      <g clip-path="url(#clip1_20043_1779385)">
        <path
          d="M22.7904 9.69886C23.4803 9.69886 24.0135 9.88704 24.4212 10.2634C24.8289 10.6397 25.0171 11.1416 25.0171 11.7688V14.7796H24.1389V14.0897H24.1076C23.7312 14.6543 23.1981 14.9365 22.5708 14.9365C22.0376 14.9365 21.5672 14.7796 21.1908 14.4661C20.8458 14.1524 20.6263 13.7134 20.6263 13.2429C20.6263 12.7411 20.8145 12.3334 21.1908 12.0197C21.5672 11.7061 22.1004 11.5807 22.7276 11.5807C23.2921 11.5807 23.7312 11.6748 24.0762 11.8943V11.6748C24.0762 11.382 23.9669 11.0893 23.7483 10.8986L23.6998 10.8593C23.4489 10.6398 23.1353 10.5143 22.7904 10.5143C22.2572 10.5143 21.8495 10.7339 21.5672 11.173L20.7518 10.6711C21.2535 10.0124 21.9122 9.69886 22.7904 9.69886ZM18.3682 7.56616C18.9309 7.56616 19.4657 7.762 19.8933 8.12719L19.9677 8.19337C20.4068 8.56974 20.6263 9.1343 20.6263 9.73018C20.6263 10.3261 20.4068 10.8593 19.9677 11.2669C19.5286 11.6746 18.9955 11.8942 18.3682 11.8942L16.8628 11.8628V14.7796H15.9219V7.56616H18.3682ZM22.9157 12.3333C22.5394 12.3333 22.2258 12.4274 21.9749 12.6156C21.724 12.7724 21.5985 12.9919 21.5985 13.2742C21.5985 13.5251 21.724 13.7446 21.9122 13.8701C22.1317 14.0269 22.3826 14.121 22.6335 14.121C22.9848 14.121 23.336 13.9843 23.6108 13.7367L23.6685 13.6819C23.9821 13.3996 24.1389 13.0546 24.1389 12.6783C23.8567 12.4588 23.4489 12.3333 22.9158 12.3333M18.431 8.44425H16.8629V10.9534H18.431C18.7759 10.9534 19.1209 10.828 19.3405 10.5771C19.8423 10.1067 19.8423 9.32258 19.3719 8.85209L19.3405 8.82072C19.0896 8.56984 18.7759 8.41302 18.4309 8.4444M30.0979 9.85567L26.993 16.975H26.0521L27.2125 14.4974L25.1739 9.88704H26.1775L27.6515 13.431H27.6829L29.1256 9.88704H30.0979V9.85567Z"
          fill="#5F6368"
        />
        <path
          d="M13.1314 11.2356C13.1314 10.9534 13.1001 10.6711 13.0687 10.3889H9.14844V11.9884H11.3752C11.2811 12.4901 10.9988 12.9606 10.5598 13.2429V14.2778H11.9083C12.6924 13.5565 13.1314 12.4901 13.1314 11.2356Z"
          fill="#4285F4"
        />
        <path
          d="M9.14805 15.2815C10.2771 15.2815 11.218 14.9051 11.908 14.2779L10.5594 13.2429C10.183 13.4938 9.71256 13.6506 9.14805 13.6506C8.08168 13.6506 7.14079 12.9293 6.82717 11.9257H5.44727V12.992C6.16859 14.4033 7.57991 15.2815 9.14805 15.2815Z"
          fill="#34A853"
        />
        <path
          d="M6.82685 11.9257C6.63871 11.4238 6.63871 10.8593 6.82685 10.3262V9.25983H5.44695C4.85102 10.4203 4.85102 11.8002 5.44695 12.992L6.82685 11.9257Z"
          fill="#FBBC04"
        />
        <path
          d="M9.14798 8.63257C9.74386 8.63257 10.3084 8.85212 10.7475 9.25982L11.9393 8.06806C11.1865 7.37806 10.1829 6.97036 9.1793 7.00168C7.61116 7.00168 6.16852 7.87987 5.47852 9.29119L6.85847 10.3575C7.14072 9.35389 8.0816 8.63257 9.14798 8.63257Z"
          fill="#EA4335"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_20043_1779385">
        <rect width="36" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_20043_1779385">
        <rect
          width="25.098"
          height="10"
          fill="white"
          transform="translate(5 7)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
